import { useEffect } from 'react'
import { useRouteMatch } from 'react-router-dom'
import CreativeAdd from 'features/creative/add/CreativeAdd'
import CreativeList from 'features/creative/list/CreativeList'
import { useDispatch } from 'react-redux'
import {
  fetchChannels,
  resetFilters,
} from 'features/creative/list/creativeListFilterSlice'
import { reset } from 'features/creative/list/creativeListSlice'

const CreativeListAndDetail = () => {
  const { path } = useRouteMatch()
  const dispatch = useDispatch()
  useEffect(() => () => dispatch(reset()), [dispatch])
  useEffect(() => () => dispatch(resetFilters()), [dispatch])
  useEffect(() => {
    dispatch(fetchChannels())
  }, [dispatch])
  return path === '/:accountId(\\d+)/creatives/:creativeId(\\d+)' ? (
    <CreativeAdd readOnly />
  ) : (
    <CreativeList />
  )
}

export default CreativeListAndDetail
